// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "com.caesiumlab",
    name: "Caesium",
    homepage: "https://caesiumlab.com/",
    image_id: "b3a456db-43c7-463c-cc3c-8c550c5b9500",
    app: {
        browser: null,
        ios: null,
        android: "https://play.google.com/store/apps/details?id=com.csm_app",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "caesium-app://walletconnect",
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map